Human readable descriptions of the remuneration package.

This field is optional and limited to a single element.
Descriptions longer than 50 characters will be truncated to 50 characters.
